import Image from 'next/image'
import classNames from 'classnames'
function StateItem({ state }) {

  return (
    <div className={classNames(`box-border flex flex-col items-center w-[146px] rounded-[23px] border-solid`)}>
      <div
        id="head"
        className='w-[99%] h-[58px] rounded-t-[23px] flex justify-center align-middle'
        style={{
          backgroundColor: state.background,
        }}
      >
        <Image src={state.thumb} width={97} height={83} style={{
            position:"relative",
            bottom:"25px"
        }} alt={state.name}/>
      </div>
      <div id="body" className='flex flex-col whitespace-nowrap justify-center items-center mt-[8px] pb-[12px]'>
        <span className='font-bold text-center font-noto-sans  text-[16px] md:text-[28px] leading-[24px] text-greyTitleBase900'>{state.name}</span>
        <span className='text-center font-noto-sansNormal text-[14px] md:text-[28px] leading-[24px] text-greyTertiaryBase500'>{state.districts} districts</span>
        
      </div>
    </div>
  )
}

export default StateItem
